import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/reset.css'
import '@/assets/css/tailwind.css'

const Vue = createApp(App)
Vue.use(router)
Vue.mount('#app')
